<template>
  <div id="ContractDiscountView">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>

        <template v-if="addDiscount==true">
            <form autocomplete="off" class="form-horizontal basic-form-container add-user-form-title " id="ContractAssetDetailForm" >

              <div class="form-row row-cols-md-4 row-cols-1">

                  <div class="col form-group">
                      <label class="control-label require" for="discountTime">Discount Slot</label>
                      <v-select v-model="discountTime" name="discountTime" placeholder="Select Discount Slot"
                          label="text"
                          :options="discountTimeArr">
                      </v-select>
                      <div class="field-error">{{ discountTime_error_msg }}</div>
                  </div>

                  <template v-if="discountTime == 'Period'">

                    <div class="col form-group">
                        <label class="control-label require" for="code">Period</label>
                        <v-select v-model="periodSelection" name="periodSelection" placeholder="Select Period"
                                label="text"
                                :options="periodArr">
                        </v-select>
                        <div class="field-error">{{ periodSelection_error_msg }}</div>
                    </div>

                    <div class="col form-group" v-if="periodSelection != '' && periodSelection != null">
                        <label class="control-label require" for="period">Period Time</label>

                        <!--input  type="text" class="form-control" v-model="period"
                        id="period" placeholder="Enter Period" name="period" @keypress="isNumCheck($event)"-->

                        <v-select v-if="periodSelection == 'Year'" v-model="period" name="period"
                        placeholder="Select Year"
                                label="text"
                                :options="yearArr">
                        </v-select>


                        <div class="input-group" v-if="periodSelection == 'Month'">
                            <date-picker placeholder="MM/YYYY" id="monthSelect" name="monthSelect"
                            v-model="monthSelect" :config="optionsMonth"></date-picker>
                            <label for="termination_date" class="fp-calendar input-calender-icon"></label>
                        </div>


                        <div class="field-error">{{ period_error_msg }}</div>
                    </div>

                  </template>


                  <template v-if="discountTime == 'Range'">

                    <div class="col form-group">
                        <label class="control-label require" for="code">From Date</label>
                        <div class="input-group">
                            <date-picker placeholder="MM/DD/YYYY" id="from_date" name="from_date"
                            v-model="from_date" :config="optionsDate"></date-picker>
                            <label for="termination_date" class="fp-calendar input-calender-icon"></label>
                        </div>
                        <div class="field-error">{{ from_date_error_msg }}</div>
                    </div>

                    <div class="col form-group">
                        <label class="control-label require" for="code">To Date</label>
                        <div class="input-group">
                            <date-picker placeholder="MM/DD/YYYY" id="to_date" name="to_date"
                            v-model="to_date" :config="optionsDate"></date-picker>
                            <label for="termination_date" class="fp-calendar input-calender-icon"></label>
                        </div>
                        <div class="field-error">{{ to_date_error_msg }}</div>
                    </div>

                  </template>


                  <div class="col form-group" style="padding-top: 28px;" v-if="discountTime == 'Period'">
                    <div class="custom-checkbox">
                        <label class="checkbox-custom">
                            Recurring
                            <input type="checkbox" v-model="is_recurring" id="recurring" name="recurring">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                  </div>


                  <div class="col form-group">
                      <label class="control-label require" for="discountTime">Discount Type</label>
                      <v-select v-model="discountType" name="discountType"
                      placeholder="Select Discount Type"
                          label="text"
                          :options="discountTypeArr">
                      </v-select>
                      <div class="field-error">{{ discountType_error_msg }}</div>
                  </div>

                  <div class="col form-group" v-if="discountType != '' && discountType != null">
                      <label class="control-label require" for="discountVal">Discount</label>

                      <input v-if="discountType == 'Amount'" type="text" class="form-control" v-model="discountVal"
                      @blur="discountVal = leaveFocus($event)"
                      @focus="discountVal = enterVal($event)"
                        id="discountVal" placeholder="Enter Amount" name="period" @keypress="isAmountCheck($event)">

                      <input v-if="discountType == '%'" type="text" class="form-control" v-model="discountPer"
                        id="discountPer" placeholder="Enter %" name="discountPer" @keypress="isPercentCheck($event)">

                      <div class="field-error">{{ discountVal_error_msg }}</div>
                  </div>


                  <div class="col form-group">
                      <label class="control-label" for="comment">Comment</label>
                      <textarea type="text" v-model="comment" id="comment"
                      rows="2" name="comment" placeholder="Comment"
                      class="form-control rounded-0">
                      </textarea>

                      <div class="field-error">{{ comment_error_msg }}</div>
                  </div>


                  <div class="col form-group">
                      <label class="control-label require" for="discountTime">Discount Applied on:</label>
                      <v-select v-model="discountApplied" name="discountApplied" placeholder="Select Discount Applied on"
                          label="text"
                          :options="discountAppliedArr">
                      </v-select>
                      <div class="field-error">{{ discountApplied_error_msg }}</div>
                  </div>



              </div>

              <div class="field-error">{{ selection_missing_msg }}</div>

              <section class="internal-container border-top-table-fl">
                <div class="view-page-table bg-white data-table p-0">
                    <vue-good-table
                        ref="listContractAssetTable"
                        title="Contract Asset"
                        @on-selected-rows-change="selectionChanged"

                        :columns="columns"
                        :rows="rows"
                        max-height="600px"
                        :totalRows="totalRecords"
                        :pagination-options="{
                            enabled: true,
                            position:'top',
                            mode: 'records',
                            perPage: 50,
                            perPageDropdown:[50,100],
                            dropdownAllowAll: false,
                        }"
                        :search-options="{
                            enabled: false,
                            placeholder: 'Search Mileage Upload Detail',
                        }"
                        :select-options="{
                            enabled: true,
                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                            selectionInfoClass: 'custom-class',
                            selectionText: 'rows selected',
                            clearSelectionText: 'clear',
                        }"
                        :sort-options="{
                            enabled: true,
                        }">
                        <div slot="emptystate">
                            No Data Found.
                        </div>
                        <!--template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <template v-if="props.column.field == 'action'">
                                    <a v-if="props.row.discarded.toLowerCase() == 'no'" href="javascript:void(0);" title="Edit Reading" class="fp-edit" v-on:click.prevent="onCellClick(props)"></a>
                                </template>
                                <template v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </template>
                            </div>
                        </template-->
                        <!--div slot="selected-row-actions"-->
                            <!-- <button id="undoDiscardedBtn" v-on:click.prevent="undoDiscarded()" class="btn btn-primary">Undo Discarded</button> -->
                            <!--button id="postMileageBtn" v-on:click.prevent="postMileage()" class="btn btn-primary">Post</button>
                            <button id="removeDiscaredBtn" v-on:click.prevent="removeDiscarded('')" class="btn btn-primary">Delete</button>
                        </div-->
                    </vue-good-table>
                </div>
            </section>

              <div v-if="$parent.canAddContractDiscount" class="btn-groups">
                  <button type="button" title="Edit Asset" class="btn btn-primary"  v-on:click="createContractDiscount()">
                  <i class="fp-save"> </i>   Save </button>
                  <button type="button"  title="Edit Asset" class="btn btn-tertiary"  v-on:click="backDiscountList()">
                  <i class="fp-close"> </i> Cancel</button>
              </div>
            </form>





        </template>

        <template v-else>


          <div v-show="$parent.canAddContractDiscount" class="btn-groups text-right mb-4">
              <button title="Add Discount" class="btn btn-primary"  v-on:click="addDiscountClick()">
                  <i class="fp-add"></i> Add
              </button>
          </div>

          <h5 v-if="foundDiscount==false">No Discount Found...</h5>

          <div class="table-responsive-sm">
              <table aria-describedby="table" id="" class="table table-sm table-bordered font-1" v-if="foundDiscount==true">
                  <thead>
                      <tr class="table-primary">
                          <th>Discount</th>
                          <th>Period</th>
                          <th>From Date</th>
                          <th>To Date</th>
                          <th>Recurring</th>
                          <th>Comment</th>
                          <th>Applied On</th>
                          <th>Action</th>
                      </tr>
                  </thead>
                  <tbody>
                      <template v-if="discData && discData.length > 0">
                          <template v-for="(record, index) in discData">
                              <tr v-bind:key="'recordRow'+index">
                                  <td>{{record.discount}}</td>
                                  <td>{{record.period}}</td>
                                  <td>{{record.from_date}}</td>
                                  <td>{{record.to_date}}</td>
                                  <td>{{record.is_recurring}}</td>
                                  <td>{{record.comment}}</td>
                                  <td>{{record.applied_for}}</td>
                                  <td>
                                      <button id="editDiscountBtn" v-on:click.prevent="isEditClick(index, record)" class="fp-edit ml-1"></button>

                                      <button id="editDiscountBtn" v-on:click.prevent="isDeleteClick(index, record)" class="fp-delete ml-3"></button>
                                  </td>
                              </tr>
                          </template>
                      </template>
                      <template v-else>
                          <tr><td colspan="8" class="text-center">No Record Found</td></tr>
                      </template>
                  </tbody>
              </table>
          </div>

        </template>


  </div>
</template>

<script>

import {commonMixins} from '../mixins/commonMixins';
import moment from 'moment';
export default {
    name: "ContractDiscountView",
    mixins:[commonMixins],
    props: {
        contractId: {
            type: String,
            required: true,
            default:undefined
        }
    },
    data: () => ({
        selection_missing_msg: "",
        selectedIds: [],
        role:"",
        loading: false,
        foundDiscount: false,
        yearArr: [],
        discData: [],
        discountsArr: [],
        addDiscount: true,
        blockRemoval: true,
        discountApplied: '',
        discountAppliedArr: ['Fixed Rate', 'Variable Rate'],
        discountApplied_error_msg: '',
        discountTimeArr: ['Period', 'Range'],
        periodArr: ['Year', 'Month'],
        period: '',
        periodSelection: '',
        discountTime: '',
        periodSelection_error_msg: '',
        period_error_msg: '',
        discountTime_error_msg: '',
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
        },
        optionsMonth: {
            format: 'MM/YYYY',
            useCurrent: false,
        },
        monthSelect: '',
        to_date: '',
        to_date_error_msg: '',
        from_date: '',
        from_date_error_msg: '',
        is_recurring: false,
        discountTypeArr: ['%', 'Amount'],
        discountType: '',
        discountVal: '',
        discountType_error_msg: '',
        discountVal_error_msg: '',
        discountPer: '',
        comment_error_msg: '',
        comment: '',
        discountId: '',
        rows: [],
        totalRecords: [],
        columns:[
            {
                label: 'Asset',
                field: 'vehicle_id',
                width:'auto',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Asset', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label: 'Status',
                field: 'status',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Customer', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label: 'Effective Date',
                field: 'effective_date',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Start Date', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label: 'Expiry Date',
                field: 'expiry_date',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Start Date', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            }
        ],
    }),
    watch:{
      cpiratesArr() {
          var self = this;
          self.blockRemoval = self.cpiratesArr.length <= 1
      },
      to_date: function(to_date) {

        var self = this;

          if ( self.from_date != null && self.to_date != null && self.from_date != "" && self.to_date != "" ) {
                var invoiceDate = Date.parse(self.from_date);
                var dueDate = Date.parse(self.to_date);

                if( dueDate <= invoiceDate ) {
                    self.to_date_error_msg = "To Date should be greater than From Date.";
                } else {
                    self.to_date_error_msg = "";
                }
            }
        },
        //check permission change
        // permissions: function (permissions) {
        //     var self = this;
        //     if (permissions.length > 0) {
        //         for (var i = 0; i < permissions.length; i++) {
        //             if (permissions[i].name == 'add_contract_discount') {
        //                 self.canAddContractDiscount = true;
        //             }
        //         }
        //     }

        // }

    },
    created: function() {

    },
    mounted: function() {
        var self = this;
        var path = window.location.pathname;
        var pathArr = path.split("/");
        console.log("contractId ===" , self.contractId);
        self.getDiscounts();
        self.getYears();
    },
    methods: {
      getYears() {
        var self = this;
        self.yearArr = [];
        const dateStart = moment().add(-2, 'y')
        const dateEnd = moment().add(20, 'y')
        while (dateEnd.diff(dateStart, 'years') >= 0) {
          self.yearArr.push(dateStart.format('YYYY'))
          dateStart.add(1, 'year')
        }
      },
      selectionChanged(param) {
          var self = this;

          // if(param.selectedRows.length == 100) {
          //   EventBus.$emit('clear-selection', false);
          // } else {
          //   // EventBus.$emit('clear-all-flags', false);
          // }
          self.selectedIds = param.selectedRows;
          self.selection_missing_msg = "";
          // param.selectedRows.forEach(element => {

          //   self.selectedIds.push(element.id);
          //   console.log("selection click", element.id);
          // });

      },
      addDiscountClick() {
        var self = this;
        self.addDiscount = true;
        self.getContractAsset(self.discountId);
      },
      isDeleteClick(index, record) {
        var self = this;
        console.log(record);
        self.$swal({
              title: 'Are you sure to delete the Discount',
              type: 'info',
              showCancelButton: true,
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
              showCloseButton: false,
              showLoaderOnConfirm: true
          }).then((result) => {
              if (result.value) {
                self.deleteDiscount(record.id);
              } else {
                console.log("no");
              }
          });
      },
      deleteDiscount(id) {
        var self = this;
        self.loading=true;
        $.ajax({
            url: process.env.ROOT_API + "/contract/discounts/delete",
            type: "POST",
            data: {"id":id},
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;

                if (data.status == "success") {
                    self.loading=false;
                    console.log("RESULT 1 === ", data.content);
                    self.addDiscount = false;
                    self.getDiscounts();
                    self.$swal('',data.content,'success');
                } else {
                  self.$swal('',data.content,'warning');
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'contract-view-data')
            }
        });
      },
      isEditClick(index, record) {
          var self = this;
          var path = window.location.pathname;
          var segments = path.split("/");
          self.loading=true;

          $.ajax({
              url: process.env.ROOT_API + "/contract/discounts/byId",
              type: "POST",
              data: {"id":record.id},
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                  self.loading = false;

                  if (data.status == "success") {
                      self.loading=false;
                      console.log("RESULT 2 === ", data.content);
                      self.discountTime = data.content.slot;
                      if(self.discountTime == 'Range') {
                        self.from_date = data.content.from_date;
                        self.to_date = data.content.to_date;
                      }

                      self.periodSelection = data.content.period;
                      if(self.periodSelection == "Month") {
                        self.monthSelect = data.content.period_count;
                      } else {
                        self.period = data.content.period_count;
                      }



                      self.comment = data.content.comment;
                      if(data.content.discount_type == 'percentage') {
                        self.discountType = "%";
                        self.discountPer = data.content.discount;
                      } else {
                        self.discountType = "Amount";
                        self.discountVal = self.amountFormat(data.content.discount);
                      }

                      if(data.content.is_recurring == 0) {
                        self.is_recurring = false;
                      } else {
                        self.is_recurring = true;
                      }

                      if(data.content.applied_for != null) {
                        if(data.content.applied_for == 1) {
                          self.discountApplied = "Fixed Rate";
                        } else {
                          self.discountApplied = "Variable Rate";
                        }
                      } else {
                        self.discountApplied = "";
                      }

                      self.discountId = data.content.id;


                      self.addDiscount = true;

                      self.getContractAsset(self.discountId);
                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  self.generateStatusCodeMessage(jqXHR,false,'contract-view-data')
              }
          });
      },
      getDiscounts() {
          var self = this;
          var path = window.location.pathname;
          var segments = path.split("/");
          self.loading=true;
          self.addDiscount=false;
          self.discountId = '';
          $.ajax({
              url: process.env.ROOT_API + "/contract/discounts",
              type: "POST",
              data: {"contract_id":segments[3]},
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                  self.loading = false;

                  if (data.status == "success") {
                      self.loading=false;
                      console.log("RESULT 3 === ", data.content);
                      self.discData = data.content.discounts;
                      if(self.discData.length > 0) {
                        self.foundDiscount = true;
                      } else {
                        self.foundDiscount = false;
                      }
                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  self.generateStatusCodeMessage(jqXHR,false,'contract-view-data')
              }
          });

      },
      backDiscountList() {
        this.addDiscount = false;
        this.resetInput();
        this.getDiscounts();
      },
      resetInput() {
        var self = this;

        self.discountTime_error_msg = "";
        self.discountType_error_msg = "";
        self.period_error_msg = "";
        self.periodSelection_error_msg = "";
        self.from_date_error_msg = "";
        self.to_date_error_msg = "";
        self.discountVal_error_msg = "";
        self.discountApplied_error_msg = "";
        self.discountTime = "";
        self.periodSelection = "";
        self.monthSelect = "";
        self.period = "";
        self.from_date = "";
        self.to_date = "";
        self.discountType = "";
        self.discountVal = "";
        self.discountPer = "";
        self.comment = "";
        self.commediscountAppliednt = "";
        self.is_recurring = false;
      },
      createContractDiscount() {
        var self = this;
        self.discountTime_error_msg = "";
        self.discountType_error_msg = "";
        self.period_error_msg = "";
        self.periodSelection_error_msg = "";
        self.from_date_error_msg = "";
        self.to_date_error_msg = "";
        self.discountVal_error_msg = "";
        self.discountApplied_error_msg = "";
        self.selection_missing_msg = "";
        var error = false;
        if(self.contractId == "" || self.contractId == null || self.contractId == 0) {
          alert("Contract Id missing");
          error = true;
        }
        if(self.discountTime == "" || self.discountTime == null) {
          self.discountTime_error_msg = "Discount Slot is required.";
          error = true;
        } else {
          if(self.discountTime == 'Period') {

            if(self.periodSelection == '' || self.periodSelection == null) {
              self.periodSelection_error_msg = "Period Type is required.";
              error = true;
            } else {

              if(self.periodSelection == 'Month') {
                if(self.monthSelect == '' || self.monthSelect == null) {
                  self.period_error_msg = "Period Month is required.";
                  error = true;
                }
              } else {
                if(self.period == '' || self.period == null) {
                  self.period_error_msg = "Period Year is required.";
                  error = true;
                }
              }

            }



          } else {

            if(self.from_date == '' || self.from_date == null) {
              self.from_date_error_msg = "From Date is required.";
              error = true;
            }
            if(self.to_date == '' || self.to_date == null) {
              self.to_date_error_msg = "To Date is required.";
              error = true;
            }
          }
        }
        if(self.discountType == "" || self.discountType == null) {
          self.discountType_error_msg = "Discount Type is required.";
          error = true;
        } else {
          if(self.discountType == 'Amount') {
            if(self.discountVal == '' || self.discountVal == null) {
              self.discountVal_error_msg = "Discount Amount is required.";
              error = true;
            }
          } else {
            if(self.discountPer == '' || self.discountPer == null) {
              self.discountVal_error_msg = "Discount Percentage is required.";
              error = true;
            }
          }
        }

        if(self.discountApplied == "" || self.discountApplied == null) {
          self.discountApplied_error_msg = "Discount Applied is required.";
          error = true;
        }

        var ids = [];

        self.selectedIds.forEach(function(val){
          ids.push(val.id);
        });

        if(ids == "" || ids == null || ids.length == 0) {
          self.selection_missing_msg = "Asset Selection is required.";
          error = true;
        }
        console.log("self ==", ids);

        if(!error) {

          var discount = '';
          var fields = {};

          var discountType = '';
          var discount = '';
          if(self.discountType == 'Amount') {
            discountType = "amount";
            discount = self.removeFormat(self.discountVal);
          } else {
            discountType = "percentage";
            discount = self.discountPer;
          }


          var applied = '';
          if(self.discountApplied == 'Fixed Rate') {
            applied = 1;
          } else {
            applied = 2;
          }





          if(self.discountTime == 'Period') {

            var periodCount = '';
            if(self.periodSelection == 'Month') {
              periodCount = self.monthSelect;
            } else {
              periodCount = self.period;
            }


            fields = {
              id: self.discountId,
              contract_id : self.contractId,
              slot : self.discountTime,
              period_count : periodCount,
              period : self.periodSelection,
              is_recurring : self.is_recurring,
              discount_type : discountType,
              discount : discount,
              comment : self.comment,
              discountApplied : applied,
              contract_asset: ids,
            }
          } else {
            fields = {
              id: self.discountId,
              contract_id : self.contractId,
              slot : self.discountTime,
              from_date : self.from_date,
              to_date : self.to_date,
              is_recurring: false,
              discount_type : discountType,
              discount : discount,
              comment : self.comment,
              discountApplied : applied,
              contract_asset: ids,
            }
          }

          console.log(fields);

          $.ajax({
              url: process.env.ROOT_API + "/contract/discount/create",
              type: "POST",
              data: fields,
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                  self.loading = false;
                  if (data.status == "success") {
                      self.addDiscount = false;
                      self.resetInput();
                      self.getDiscounts();
                  }
                  else {

                    self.$swal('',data.content,'warning');
                      // if (data.content.length > 0) {
                      //     var err = "<ul>";
                      //     $(".alert-contract").empty();

                      //     for (var i = 0; i < data.content.length; i++) {
                      //         err += "<li>" + data.content[i] + "</li>";
                      //     }
                      //     err += "</ul>";
                      //     $(".alert-contract").append(err);
                      //     $(".alert-contract").addClass("show");

                      // }
                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  self.generateStatusCodeMessage(jqXHR,true,'contract-cpi-rate-create')
              }
          });
        }
      },
      isNumCheck: function (evt) {
          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;

          if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1)) {
              evt.preventDefault();
          } else {
              if (evt.target.value > 1) {
                  evt.preventDefault();
              } else {
                  return true;
              }

          }
      },
      getContractAsset: function(discount_id) {
        var self = this;
        self.loading=true;
        $.ajax({
            url: process.env.ROOT_API + "/contractasset/discount/" + self.contractId,
            type: "GET",
            data: {'discount_id' : discount_id},
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;

                if (data.status == "success") {
                    self.loading=false;
                    console.log("RESULT 1 === ", data.content);
                    console.log("discountId === ", self.discountId);
                    self.totalRecords = data.content.totalRecords
                    self.rows = data.content.row;


                    self.rows.forEach(element => {
                      if(element.selection_id == 1) {
                        var idx = self.rows.findIndex(obj => obj.id == element.id);
                        console.log("idx ==", idx);
                        if(idx !== -1) {
                            self.$set(self.rows[idx], 'vgtSelected', true);
                        }
                      }


                    });

                } else {
                  self.$swal('',data.content,'warning');
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'contract-view-data')
            }
        });
      }

    }

}
</script>


// WEBPACK FOOTER //
// src/components/ContractDiscountView.vue